import { Dispatch, useCallback } from 'react'
import { NavigateFunction } from 'react-router-dom'
import { QueryClient } from '@tanstack/react-query'
import ROUTES from 'src/constants/routes'
import { API } from 'src/services/config'
import { AuthAction } from '../reducers/auth.reducer'
import { destroySession } from '../services/auth.service'
import { storageService } from '../services/storage.service'

interface UseLogoutProps {
  dispatch: Dispatch<AuthAction>
  navigate: NavigateFunction
  queryClient: QueryClient
  cancelTokenRefresh: () => void
}

export function useLogout({ dispatch, navigate, queryClient, cancelTokenRefresh }: UseLogoutProps) {
  return useCallback(async () => {
    try {
      cancelTokenRefresh()
      await destroySession()
    } finally {
      storageService.clearSession()

      if (API.defaults.headers) {
        delete API.defaults.headers['Authorization']
      }

      dispatch({ type: 'LOGOUT' })
      queryClient.clear()
      navigate(ROUTES.AUTH.LOGIN, { replace: true })
    }
  }, [cancelTokenRefresh, dispatch, navigate, queryClient])
}
